import React from 'react'

const ErrorComponent = ({ error }) => {
  return <p>An Error Occurred: {error.errorCode}</p>
}

export default ErrorComponent
